import type { ClaudiStickerId } from '../../domain';
import type { ScreenParams } from './screenIds';

export type DeliveryCompletionParams = Pick<
  ScreenParams,
  'giantId' | 'characterId' | 'orderIndex'
>;

type StickerFlowTarget = {
  screen: 'deliveryResult' | 'stickerReward';
  params: ScreenParams;
};

/** After success screen CTA — show sticker queue or go straight to results. */
export function nextScreenAfterViewResults(
  unlockedStickers: ClaudiStickerId[] | undefined,
  deliveryParams: DeliveryCompletionParams,
): StickerFlowTarget {
  const stickers = unlockedStickers ?? [];
  if (stickers.length === 0) {
    return { screen: 'deliveryResult', params: deliveryParams };
  }
  const [stickerId, ...remainingStickers] = stickers;
  return {
    screen: 'stickerReward',
    params: { ...deliveryParams, stickerId, remainingStickers },
  };
}

/** After claim CTA — next sticker in queue or delivery results. */
export function nextScreenAfterClaimSticker(
  remainingStickers: ClaudiStickerId[] | undefined,
  deliveryParams: DeliveryCompletionParams,
): StickerFlowTarget {
  const remaining = remainingStickers ?? [];
  if (remaining.length === 0) {
    return { screen: 'deliveryResult', params: deliveryParams };
  }
  const [stickerId, ...rest] = remaining;
  return {
    screen: 'stickerReward',
    params: { ...deliveryParams, stickerId, remainingStickers: rest },
  };
}

/** Guard direct navigation to stickerReward without a sticker id. */
export function resolveStickerRewardScreen(
  stickerId: ClaudiStickerId | undefined,
  deliveryParams: DeliveryCompletionParams,
): StickerFlowTarget {
  if (stickerId == null) {
    return { screen: 'deliveryResult', params: deliveryParams };
  }
  return { screen: 'stickerReward', params: { ...deliveryParams, stickerId } };
}
